const errorCodes = [400, 401, 403, 409];

const showErrorNotification = error => {
  const data = error?.response?.data ? error.response.data : {};
  const code = data.code || data.status;
  return errorCodes.includes(code);
};

export default showErrorNotification;
